import { ShopifyWebhookIcon } from "@gadgetinc/widgets/src/icons/ShopifyWebhookIcon";
import { ThirdPartyIcon } from "@gadgetinc/widgets/src/icons/ThirdPartyIcon";
import { WebsiteIcon } from "@gadgetinc/widgets/src/icons/WebsiteIcon";
import { useStyletron } from "baseui";
import { HeadingXLarge, ParagraphLarge } from "baseui/typography";
import React from "react";
import type { DocsInterfaceProps } from "../../../../src/chrome/DocsInterface";
import { DocsInterface } from "../../../../src/chrome/DocsInterface";
import { SplashCard, SplashCardGrid, SplashContentContainer, colors } from "../../../../src/components/SplashPage";

const ConnectionQuickstarts = (props: DocsInterfaceProps) => {
  const [css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <SplashContentContainer $style={{ maxWidth: "980px" }}>
        <HeadingXLarge>Quickstarts</HeadingXLarge>
        <ParagraphLarge
          $style={{
            paddingTop: $theme.sizing.scale800,
            paddingBottom: $theme.sizing.scale800,
          }}
        >
          Learn how to set up different Gadget connections that automatically take care of OAuth, webhook subscriptions, frontend sessions,
          and more.
        </ParagraphLarge>
        <SplashCardGrid $maxColumns={2} className={css({ marginTop: $theme.sizing.scale1200 })}>
          <SplashCard
            icon={<WebsiteIcon $size={32} />}
            title="Web quickstart"
            color={colors.white}
            body="Learn how to make a web app with an OpenAI connection."
            href="/guides/getting-started/quickstarts/web-quickstart"
            copy="Get started →"
          />
          <SplashCard
            icon={<ShopifyWebhookIcon $size={32} />}
            title="Shopify quickstart"
            color={colors.white}
            body="Learn how to set up a Shopify connection."
            href="/guides/plugins/shopify/quickstarts/shopify-quickstart"
            copy="Get started →"
          />
          <SplashCard
            icon={<ThirdPartyIcon type="bigcommerce" $size={32} />}
            title="BigCommerce quickstart"
            color={colors.white}
            body="Learn how to set up a BigCommerce connection."
            href="/guides/getting-started/quickstarts/bigcommerce-quickstart"
            copy="Get started →"
          />
        </SplashCardGrid>
      </SplashContentContainer>
    </DocsInterface>
  );
};

export default ConnectionQuickstarts;
